import { render, staticRenderFns } from "./GerenciamentoPedidos-Aba6.vue?vue&type=template&id=2dba82fa&"
import script from "./GerenciamentoPedidos-Aba6.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoPedidos-Aba6.vue?vue&type=script&lang=js&"
import style0 from "./GerenciamentoPedidos-Aba6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports